import type { OrganisationInvitation, OrganisationMember } from '../lib/governance-api'

export type PeopleAccessSummary = {
  active: number
  suspended: number
  pendingInvitations: number
}

export function peopleAccessSummary(members: OrganisationMember[], invitations: OrganisationInvitation[], now = Date.now()): PeopleAccessSummary {
  return {
    active: members.filter((member) => member.status === 'active').length,
    suspended: members.filter((member) => member.status === 'suspended').length,
    pendingInvitations: invitations.filter((invitation) => invitation.status === 'pending' && new Date(invitation.expiresAt).getTime() > now).length,
  }
}

export function peopleAccessSummaryLabel(summary: PeopleAccessSummary) {
  return [
    `${summary.active} active ${summary.active === 1 ? 'person' : 'people'}`,
    summary.suspended ? `${summary.suspended} suspended` : null,
    `${summary.pendingInvitations} pending ${summary.pendingInvitations === 1 ? 'invitation' : 'invitations'}`,
  ].filter((part): part is string => Boolean(part)).join(' · ')
}
